import React from 'react'
import classNames from 'classnames'
import { Icon, Tooltip } from "../../../ui";
import "./style.css";

export type ImageIconProps = {
  /** The {@link Tooltip} content. */
  children?: React.ReactNode
  /** Additional class on the button. */
  className?: string
  /** The icon to show, by the app's icon name (see src/ui/theme.css). */
  icon?: string
  testId?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

/*
 * An icon button with a tooltip — a status icon in a table cell.
 */
export function ImageIcon({
  children,
  className,
  icon,
  testId,
  onClick,
}: ImageIconProps) {
  return (
    <Tooltip content={children}>
      <button
        type="button"
        data-testid={testId}
        data-tooltip={typeof children === 'string' ? children : undefined}
        className={classNames('image-icon', className)}
        onClick={onClick}
      >
        <Icon name={icon} />
      </button>
    </Tooltip>
  )
}
